import request from "@/utils/request";

// 登录
export async function setLoginRe(params) {
    return request("/dtk_go_app_api/v1/login-re", {
      method: "POST",
      data: params
    });
}
export async function getSendMsgNew(params) {
    return request("/dtk_go_app_api/v1/send-msg-new", {
      method: "GET",
      data: params
    });
} 

export async function getAddTop(params) {
    return request("/dtk_go_app_api/v1/add-top", {
      method: "GET",
      data: params
    });
} 


export async function getRobotList(params) {
    return request("/dtk-go-cloud-robot/cloud-robot/robot-list-v3", {
      method: "GET",
      data: params,
      headers: {
        AppToken: localStorage.getItem('AppToken')
      }
    });
} 

export async function getCloudInviteActivity(params) {
    return request("/taobaoapi/cloud-invite-activity", {
      method: "GET",
      data: params,
      headers: {
        AppToken: localStorage.getItem('AppToken')
      }
    });
} 


export async function getBuyList(params) {
    return request("/dtk-go-cloud-robot/cloud-robot/cloud-price-list-v3", {
      method: "GET",
      data: params,
      headers: {
        AppToken: localStorage.getItem('AppToken')
      }
    });
} 


export async function createOrderV3(params) {
    return request("/dtk-go-cloud-robot/cloud-robot/cloud-create-yfd-order-v3", {
      method: "GET",
      data: params,
      headers: {
        AppToken: localStorage.getItem('AppToken')
      }
    });
} 

export async function checkOrder(params) {
    return request("/dtk-go-cloud-robot/cloud-robot/check-buy-status", {
      method: "GET",
      data: params,
      headers: {
        AppToken: localStorage.getItem('AppToken')
      }
    });
} 

export async function getOpenId(params) {
    return request("/taobaoapi/get-openid-by-code", {
      method: "GET",
      data: params,
      headers: {
        AppToken: localStorage.getItem('AppToken')
      }
    });
} 

//转短连接
export async function getShortUrl(params) {
    return request("/dtk_go_app_api/v1/create-short-url", {
      method: "GET",
      data: params
    });
} 





// WEBPACK FOOTER //
// ./src/services/index.js